import React from 'react';
import PropTypes from 'prop-types';
import styles from './RCACellComponent.module.css';
import {
	POD,
	INVENTORY,
	PRICING,
	ASSORTMENT,
	NOT_IDENTIFIED,
} from '../../../constants/constant';
const RCACellComponent = (props) => {
	const chipsArray = typeof props?.value === 'object' ? props?.value : [];
	const rcaNameRenderer = (value) => {
		switch (value) {
			case POD:
				return 'Points of Distribution';
			case INVENTORY:
				return 'Replenishment';
			case PRICING:
				return 'Pricing';
			case ASSORTMENT:
				return 'Assortment';
			case NOT_IDENTIFIED:
				return 'Not Identified';
			// You can add many more here ...
			default:
				return value;
		}
	};

	const chipColor = (value) => {
		if (value === NOT_IDENTIFIED) {
			return styles.greyChip;
		} else {
			return styles.purpleChip;
		}
	};

	return (
		<div className={styles.horizontalChips}>
			{chipsArray?.map((item, index) => (
				<div className={chipColor(item)} key={index}>
					{rcaNameRenderer(item)}
				</div>
			))}
		</div>
	);
};

RCACellComponent.propTypes = {
	value: PropTypes.any,
};

export default RCACellComponent;
